import type { StrategyVariantSavedCohortSummary } from '@einhaus/project314-types';

type CohortCoverage = Pick<StrategyVariantSavedCohortSummary, 'pendingJobIds' | 'failedJobIds'>;

export const hasIncompleteSavedCohorts = (cohorts: readonly CohortCoverage[]): boolean =>
    cohorts.some((cohort) => cohort.pendingJobIds.length > 0 || cohort.failedJobIds.length > 0);
